var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mobile-navigation-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "mobile-navigation bg-white",
        class: { open: _vm.isMobileNavigationOpen },
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isNavigationInitialized,
                expression: "isNavigationInitialized",
              },
            ],
          },
          [
            _c("ul", { staticClass: "breadcrumb d-block p-0 m-0" }, [
              _c(
                "li",
                {
                  staticClass: "px-3 bg-danger pull-right",
                  attrs: {
                    "aria-label": _vm.$translate("Ceres::Template.closeIcon"),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.closeNavigation()
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-close",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "breadcrumb-item pl-3",
                  on: {
                    click: function ($event) {
                      return _vm.slideTo(null, true)
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-home",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [{ name: "menu", rawName: "v-menu" }],
                staticClass: "mainmenu w-100 p-0 m-0 menu-active",
                attrs: { id: "menu-1" },
              },
              [
                _vm.dataContainer1.parent && _vm.dataContainer1.parent.details
                  ? _c(
                      "li",
                      {
                        staticClass: "ddown bg-secondary",
                        on: {
                          click: function ($event) {
                            return _vm.slideTo(
                              (_vm.dataContainer1.parent &&
                                _vm.dataContainer1.parent.parent) ||
                                null,
                              true
                            )
                          },
                        },
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("a", [
                          _vm._v(
                            _vm._s(_vm.dataContainer1.parent.details[0].name)
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataContainer1.parent && _vm.dataContainer1.parent.url
                  ? _c("li", { staticClass: "ddown bg-primary" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.getCategoryUrl(
                              _vm.dataContainer1.parent.url
                            ),
                          },
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "Waldorfshop7::Template.AllFromCategory"
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(1),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(
                  _vm.dataContainer1.categories,
                  function (category, index) {
                    return _c(
                      "li",
                      {
                        staticClass: "ddown",
                        class:
                          _vm.dataContainer1.parent &&
                          _vm.dataContainer1.parent.url
                            ? "bg-secondary"
                            : "bg-color-" + (index % 10),
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: { href: _vm.getCategoryUrl(category.url) },
                            on: {
                              click: function ($event) {
                                category.childCount
                                  ? _vm.slideTo(category, false, $event)
                                  : _vm.openCategory(category.url)
                              },
                            },
                          },
                          [_vm._v(_vm._s(category.details[0].name))]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "nav-direction",
                            on: {
                              click: function ($event) {
                                category.childCount
                                  ? _vm.slideTo(category)
                                  : _vm.openCategory(category.url)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa",
                              class: category.childCount
                                ? "fa-chevron-right text-white"
                                : "",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        ),
                      ]
                    )
                  }
                ),
                _vm._v(" "),
                _vm.dataContainer1.categories[0]
                  ? _vm._l(
                      _vm.dataContainer1.categories[0].siblingCount -
                        _vm.dataContainer1.categories.length,
                      function (number) {
                        return _c("li", { staticClass: "ddown" }, [
                          _c("span", {
                            staticClass: "nav-placeholder m-3",
                            style: { width: Math.random() * 20 + 60 + "%" },
                          }),
                        ])
                      }
                    )
                  : _vm.dataContainer1.parent
                  ? _vm._l(
                      _vm.dataContainer1.parent.childCount,
                      function (number) {
                        return _c("li", { staticClass: "ddown" }, [
                          _c("span", {
                            staticClass: "nav-placeholder m-3",
                            style: { width: Math.random() * 20 + 60 + "%" },
                          }),
                        ])
                      }
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("li", { staticClass: "ddown bg-primary" }, [
                  _c(
                    "a",
                    {
                      staticClass: "mobile-blog",
                      attrs: { href: "https://blog.waldorfshop.eu" },
                    },
                    [_vm._v("Blog")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "nav-direction text-right" }, [
                    _c(
                      "a",
                      {
                        staticClass: "py-0 px-1",
                        attrs: {
                          href: "https://www.facebook.com/waldorfshop",
                          title: "Facebook",
                          target: "_blank",
                        },
                      },
                      [
                        _c("lazy-img", {
                          attrs: {
                            "image-url":
                              "https://cdn02.plentymarkets.com/rm2ukznxe8l9/frontend/Layout/icons2023/ws_icon_facebook_header.webp",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "py-0 px-1",
                        attrs: {
                          href: "https://www.instagram.com/waldorfshop.eu",
                          title: "Instagram",
                          target: "_blank",
                        },
                      },
                      [
                        _c("lazy-img", {
                          attrs: {
                            "image-url":
                              "https://cdn02.plentymarkets.com/rm2ukznxe8l9/frontend/Layout/icons2023/ws_icon_insta_header.webp",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "py-0 px-1",
                        attrs: {
                          href: "https://www.youtube.com/channel/UCt-FjyLXUCN_WPVhaJHSD7A",
                          title: "YouTube",
                          target: "_blank",
                        },
                      },
                      [
                        _c("lazy-img", {
                          attrs: {
                            "image-url":
                              "https://cdn02.plentymarkets.com/rm2ukznxe8l9/frontend/Layout/icons2023/ws_icon_youtube_header.webp",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("client-only", [
                  _c("li", { staticClass: "ddown" }, [
                    _vm.hrefLangLinks.length > 0
                      ? _c(
                          "div",
                          { staticClass: "m-3" },
                          [
                            _c("strong", { staticClass: "mb-1 d-block" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.headerSelectLanguage"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.hrefLangLinks, function (hreflang) {
                              return _c(
                                "a",
                                {
                                  staticClass: "badge text-uppercase p-2",
                                  class: {
                                    "badge-primary": _vm.isSameLanguage(
                                      hreflang.hreflang
                                    ),
                                    "text-secondary": !_vm.isSameLanguage(
                                      hreflang.hreflang
                                    ),
                                  },
                                  attrs: { href: hreflang.href },
                                },
                                [_vm._v(_vm._s(hreflang.hreflang))]
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "nav-direction" },
                      [
                        _c(
                          "user-login-handler",
                          {
                            attrs: {
                              "show-login": true,
                              "show-registration": false,
                            },
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                attrs: {
                                  "data-toggle": "modal",
                                  "aria-label": _vm.$translate(
                                    "Ceres::Template.login"
                                  ),
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "mx-auto d-block",
                                  attrs: {
                                    src: "https://cdn02.plentymarkets.com/rm2ukznxe8l9/frontend/Layout/icons2023/ws_icon_login.svg",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "d-none d-sm-block" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate("Ceres::Template.login")
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [{ name: "menu", rawName: "v-menu" }],
                staticClass: "mainmenu w-100 p-0 m-0",
                attrs: { id: "menu-2" },
              },
              [
                _vm.dataContainer2.parent && _vm.dataContainer2.parent.details
                  ? _c(
                      "li",
                      {
                        staticClass: "ddown bg-secondary",
                        on: {
                          click: function ($event) {
                            return _vm.slideTo(
                              (_vm.dataContainer2.parent &&
                                _vm.dataContainer2.parent.parent) ||
                                null,
                              true
                            )
                          },
                        },
                      },
                      [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("a", [
                          _vm._v(
                            _vm._s(_vm.dataContainer2.parent.details[0].name)
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataContainer2.parent && _vm.dataContainer2.parent.url
                  ? _c("li", { staticClass: "ddown bg-primary" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.getCategoryUrl(
                              _vm.dataContainer2.parent.url
                            ),
                          },
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "Waldorfshop7::Template.AllFromCategory"
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(3),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(
                  _vm.dataContainer2.categories,
                  function (category, index) {
                    return _c(
                      "li",
                      {
                        staticClass: "ddown",
                        class:
                          _vm.dataContainer2.parent &&
                          _vm.dataContainer2.parent.url
                            ? "bg-secondary"
                            : "bg-color-" + (index % 10),
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: { href: _vm.getCategoryUrl(category.url) },
                            on: {
                              click: function ($event) {
                                category.childCount
                                  ? _vm.slideTo(category, false, $event)
                                  : _vm.openCategory(category.url)
                              },
                            },
                          },
                          [_vm._v(_vm._s(category.details[0].name))]
                        ),
                        _vm._v(" "),
                        category.childCount
                          ? _c(
                              "span",
                              {
                                staticClass: "nav-direction",
                                on: {
                                  click: function ($event) {
                                    return _vm.slideTo(category)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa",
                                  class: category.childCount
                                    ? "fa-chevron-right text-white"
                                    : "",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  }
                ),
                _vm._v(" "),
                _vm.dataContainer2.categories[0]
                  ? _vm._l(
                      _vm.dataContainer2.categories[0].siblingCount -
                        _vm.dataContainer2.categories.length,
                      function (number) {
                        return _c("li", { staticClass: "ddown" }, [
                          _c("span", {
                            staticClass: "nav-placeholder m-3",
                            style: { width: Math.random() * 20 + 60 + "%" },
                          }),
                        ])
                      }
                    )
                  : _vm.dataContainer2.parent
                  ? _vm._l(
                      _vm.dataContainer2.parent.childCount,
                      function (number) {
                        return _c("li", { staticClass: "ddown" }, [
                          _c("span", {
                            staticClass: "nav-placeholder m-3",
                            style: { width: Math.random() * 20 + 60 + "%" },
                          }),
                        ])
                      }
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("li", { staticClass: "ddown bg-primary" }, [
                  _c(
                    "a",
                    {
                      staticClass: "mobile-blog",
                      attrs: { href: "https://blog.waldorfshop.eu" },
                    },
                    [_vm._v("Blog")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "nav-direction text-right" }, [
                    _c(
                      "a",
                      {
                        staticClass: "py-0 px-1",
                        attrs: {
                          href: "https://www.facebook.com/waldorfshop",
                          title: "Facebook",
                          target: "_blank",
                        },
                      },
                      [
                        _c("lazy-img", {
                          attrs: {
                            "image-url":
                              "https://cdn02.plentymarkets.com/rm2ukznxe8l9/frontend/Layout/icons2023/ws_icon_facebook_header.webp",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "py-0 px-1",
                        attrs: {
                          href: "https://www.instagram.com/waldorfshop.eu",
                          title: "Instagram",
                          target: "_blank",
                        },
                      },
                      [
                        _c("lazy-img", {
                          attrs: {
                            "image-url":
                              "https://cdn02.plentymarkets.com/rm2ukznxe8l9/frontend/Layout/icons2023/ws_icon_insta_header.webp",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "py-0 px-1",
                        attrs: {
                          href: "https://www.youtube.com/channel/UCt-FjyLXUCN_WPVhaJHSD7A",
                          title: "YouTube",
                          target: "_blank",
                        },
                      },
                      [
                        _c("lazy-img", {
                          attrs: {
                            "image-url":
                              "https://cdn02.plentymarkets.com/rm2ukznxe8l9/frontend/Layout/icons2023/ws_icon_youtube_header.webp",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("client-only", [
                  _c("li", { staticClass: "ddown" }, [
                    _vm.hrefLangLinks.length > 0
                      ? _c(
                          "div",
                          { staticClass: "m-3" },
                          [
                            _c("strong", { staticClass: "mb-1 d-block" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.headerSelectLanguage"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.hrefLangLinks, function (hreflang) {
                              return _c(
                                "a",
                                {
                                  staticClass: "badge text-uppercase p-2",
                                  class: {
                                    "badge-primary": _vm.isSameLanguage(
                                      hreflang.hreflang
                                    ),
                                    "text-secondary": !_vm.isSameLanguage(
                                      hreflang.hreflang
                                    ),
                                  },
                                  attrs: { href: hreflang.href },
                                },
                                [_vm._v(_vm._s(hreflang.hreflang))]
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "nav-direction" },
                      [
                        _c(
                          "user-login-handler",
                          {
                            attrs: {
                              "show-login": true,
                              "show-registration": false,
                            },
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                attrs: {
                                  "data-toggle": "modal",
                                  "aria-label": _vm.$translate(
                                    "Ceres::Template.login"
                                  ),
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "mx-auto d-block",
                                  attrs: {
                                    src: "https://cdn02.plentymarkets.com/rm2ukznxe8l9/frontend/Layout/icons2023/ws_icon_login.svg",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "d-none d-sm-block" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate("Ceres::Template.login")
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ],
              2
            ),
          ]
        ),
        _vm._v(" "),
        !_vm.isNavigationInitialized
          ? [
              _c("ul", { staticClass: "breadcrumb" }, [
                _c("li", {
                  staticClass: "btn-close",
                  on: {
                    click: function ($event) {
                      return _vm.closeNavigation()
                    },
                  },
                }),
                _vm._v(" "),
                _vm._m(4),
              ]),
              _vm._v(" "),
              _c("loading-animation"),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", {
      staticClass: "mobile-navigation-overlay",
      on: {
        click: function ($event) {
          return _vm.closeNavigation()
        },
      },
    }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "nav-direction btn-up" }, [
      _c("i", {
        staticClass: "fa fa-chevron-left",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "nav-direction" }, [
      _c("i", {
        staticClass: "fa fa-lg fa-chevron-circle-right",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "nav-direction btn-up" }, [
      _c("i", {
        staticClass: "fa fa-chevron-left",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "nav-direction" }, [
      _c("i", {
        staticClass: "fa fa-lg fa-chevron-circle-right",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "breadcrumb-item" }, [
      _c("i", { staticClass: "fa fa-home", attrs: { "aria-hidden": "true" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }